<template>
  <!-- PERBAIKAN: Mengubah :value menjadi :visible dan menangkap event @hidden -->
  <b-modal
    :visible="value"
    @hidden="$emit('input', false)"
    title="Detail SPH RAB Proyek"
    title-class="font-weight-bold text-dark"
    size="xl"
    centered
    hide-footer
    no-close-on-backdrop
  >
    <div v-if="loading" class="text-center my-5">
      <b-spinner variant="primary" label="Memuat data..."></b-spinner>
      <p class="mt-2 text-muted">Sedang mengambil rincian RAB...</p>
    </div>

    <div v-else>
      <div class="mb-3 p-3 bg-light rounded border row mx-0">
        <div class="col-sm-6">
          <h6 class="mb-1 font-weight-bold">
            Nama Proyek: <span class="text-primary">{{ projectName }}</span>
          </h6>
          <small class="text-muted d-block"
            >Kode Proyek: {{ projectCode }}</small
          >
        </div>
        <div class="col-sm-6 text-sm-right mt-2 mt-sm-0">
          <h6 class="mb-1 font-weight-bold">
            Total SPH Terkalkulasi:
            <span class="text-info">{{ formatRupiah(grandTotalSph) }}</span>
          </h6>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table table-sm table-bordered custom-table-modal">
          <thead class="text-nowrap text-center">
            <tr>
              <th rowspan="2" class="align-middle" width="5%">No</th>
              <th rowspan="2" class="align-middle">Uraian Justifikasi</th>
              <th rowspan="2" class="align-middle" width="7%">VOL</th>
              <th rowspan="2" class="align-middle" width="7%">Periode</th>
              <th rowspan="2" class="align-middle" width="7%">SAT</th>
              <th colspan="2" class="text-center">Harga SPH Vendor</th>
            </tr>
            <tr>
              <th width="12%">HARGA</th>
              <th width="13%">JUMLAH</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dataRows" :key="index">
              <td class="text-center">{{ item.no || index + 1 }}</td>
              <td class="th-td-35">{{ item.uraian_justifikasi }}</td>
              <td
                v-if="
                  item.volume !== null ||
                    (!item.proyek_id_header && !item.id_header)
                "
                class="text-center align-middle"
                :rowspan="item.rowspan_volume || 1"
                >{{ item.volume }}</td
              >
              <td
                v-if="
                  item.periode !== null ||
                    (!item.proyek_id_header && !item.id_header)
                "
                class="text-center align-middle"
                :rowspan="item.rowspan_periode || 1"
                >{{ item.periode }}</td
              >
              <td
                v-if="
                  item.satuan !== null ||
                    (!item.proyek_id_header && !item.id_header)
                "
                class="text-center align-middle text-uppercase"
                :rowspan="item.rowspan_satuan || 1"
                >{{ item.satuan ? item.satuan.toUpperCase() : '' }}</td
              >
              <td
                v-if="
                  item.sph !== null ||
                    (!item.proyek_id_header && !item.id_header)
                "
                class="text-right align-middle"
                :rowspan="item.rowspan_sph || 1"
                >{{ item.sph ? formatRupiah(item.sph) : '' }}</td
              >
              <td
                v-if="
                  item.sph !== null ||
                    (!item.proyek_id_header && !item.id_header)
                "
                class="text-right align-middle font-weight-bold text-primary"
                :rowspan="item.rowspan_sph || 1"
                >{{ item.sph ? formatRupiah(hitungTotalSphRow(item)) : '' }}</td
              >
            </tr>
            <tr v-if="dataRows.length === 0">
              <td colspan="9" class="text-center text-muted py-4"
                >Tidak ada data rincian RAB untuk proyek ini.</td
              >
            </tr>
          </tbody>
          <tfoot v-if="dataRows.length > 0">
            <tr class="font-weight-bold">
              <td
                colspan="5"
                class="text-right text-uppercase py-2 align-middle"
                >Grand Total:</td
              >
              <td class="text-center bg-white-disabled"></td>
              <td
                class="text-right text-primary py-2 font-weight-bold align-middle"
                >{{ formatRupiah(grandTotalSph) }}</td
              >
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
    <div class="text-right mt-3 border-top pt-3">
      <b-button variant="secondary" @click="$emit('input', false)"
        >Tutup</b-button
      >
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'SphModal',
  props: {
    value: { type: Boolean, required: true },
    loading: { type: Boolean, default: false },
    projectName: { type: String, default: '' },
    projectCode: { type: String, default: '' },
    dataRows: { type: Array, default: () => [] },
    formatRupiah: { type: Function, required: true },
    hitungTotalSphRow: { type: Function, required: true },
    hitungTotalSpkRow: { type: Function, required: true },
  },
  computed: {
    grandTotalSph() {
      return this.dataRows.reduce(
        (total, rab) => total + this.hitungTotalSphRow(rab),
        0
      )
    },
  },
}
</script>
